(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCountdown() {
    document.querySelectorAll('[data-pl-countdown]').forEach(function (root) {
      var targetStr = root.dataset.plCountdown;
      if (!targetStr) return;
      var target = new Date(targetStr.replace(' ', 'T')).getTime();
      if (isNaN(target)) return;
      var diasEl = root.querySelector('[data-pl-cd-dias]');
      var horasEl = root.querySelector('[data-pl-cd-horas]');
      var minEl = root.querySelector('[data-pl-cd-min]');
      var segEl = root.querySelector('[data-pl-cd-seg]');

      function pad(n) { return String(n).padStart(2, '0'); }

      function tick() {
        var now = Date.now();
        var diff = target - now;
        if (diff <= 0) {
          if (diasEl) diasEl.textContent = '00';
          if (horasEl) horasEl.textContent = '00';
          if (minEl) minEl.textContent = '00';
          if (segEl) segEl.textContent = '00';
          clearInterval(timer);
          return;
        }
        var dias = Math.floor(diff / (1000 * 60 * 60 * 24));
        var horas = Math.floor((diff / (1000 * 60 * 60)) % 24);
        var min = Math.floor((diff / (1000 * 60)) % 60);
        var seg = Math.floor((diff / 1000) % 60);
        if (diasEl) diasEl.textContent = pad(dias);
        if (horasEl) horasEl.textContent = pad(horas);
        if (minEl) minEl.textContent = pad(min);
        if (segEl) segEl.textContent = pad(seg);
      }

      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  function initReveal() {
    var els = document.querySelectorAll('.pl-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pl-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pl-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function initMarquee() {
    document.querySelectorAll('[data-pl-marquee]').forEach(function (wrap) {
      var track = wrap.querySelector('.pl-marquee-track');
      if (!track || track.dataset.plDuped) return;
      track.innerHTML += track.innerHTML;
      track.dataset.plDuped = 'true';
    });
  }

  function initFaq() {
    document.querySelectorAll('.pl-faq-item').forEach(function (item) {
      var btn = item.querySelector('.pl-faq-q');
      var answer = item.querySelector('.pl-faq-a');
      if (!btn || !answer) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('pl-open');
        item.closest('.pl-faq-list').querySelectorAll('.pl-faq-item').forEach(function (other) {
          other.classList.remove('pl-open');
          other.querySelector('.pl-faq-a').style.maxHeight = null;
          other.querySelector('.pl-faq-q').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('pl-open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initGaleriaCarrusel() {
    document.querySelectorAll('[data-pl-galeria]').forEach(function (wrap) {
      var track = wrap.querySelector('.pl-galeria-track');
      var prev = wrap.querySelector('[data-pl-prev]');
      var next = wrap.querySelector('[data-pl-next]');
      if (!track) return;
      function step(dir) {
        var item = track.querySelector('.pl-galeria-item');
        var amount = item ? item.getBoundingClientRect().width + 20 : 280;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  }

  function initCountUp() {
    var els = document.querySelectorAll('.pl-countup');
    if (!els.length) return;
    function animate(el) {
      var target = parseFloat(el.dataset.target || el.textContent) || 0;
      var decimals = (el.dataset.target && el.dataset.target.indexOf('.') > -1) ? 1 : 0;
      var duration = 1200;
      var start = null;
      function frame(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = (target * eased).toFixed(decimals);
        if (progress < 1) requestAnimationFrame(frame);
        else el.textContent = target.toFixed(decimals);
      }
      if (reduceMotion) { el.textContent = target.toFixed(decimals); return; }
      requestAnimationFrame(frame);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animate); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { animate(entry.target); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) {
      el.dataset.target = el.textContent.trim();
      el.textContent = '0';
      obs.observe(el);
    });
  }

  function initProductoGaleria() {
    document.querySelectorAll('[data-pl-producto-galeria]').forEach(function (root) {
      var mainImg = root.querySelector('[data-pl-main-img]');
      var thumbs = root.querySelectorAll('.pl-producto-gal-thumb');
      if (!mainImg || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('pl-active'); });
          thumb.classList.add('pl-active');
          var full = thumb.dataset.full;
          if (full) mainImg.src = full;
          mainImg.alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : mainImg.alt;
        });
      });
    });
  }

  function formatMoney(cents, format) {
    var amount = cents / 100;
    var format_ = format || '{{amount}} €';
    var value;
    if (/with_comma_separator/.test(format_)) {
      value = amount.toFixed(2).replace('.', ',');
    } else {
      value = amount.toFixed(2);
    }
    return format_.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, value);
  }

  function initProductoVariantes() {
    document.querySelectorAll('[data-pl-producto-form]').forEach(function (form) {
      var root = form.closest('.pl-producto-buy') || form;
      var dataEl = form.querySelector('[data-pl-variantes-json]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var idInput = form.querySelector('input[name="id"]');
      var priceEl = root.querySelector('[data-pl-precio]');
      var compareEl = root.querySelector('[data-pl-precio-compare]');
      var descuentoEl = root.querySelector('[data-pl-descuento]');
      var addBtn = form.querySelector('[data-pl-add-btn]');
      var stockEl = root.querySelector('[data-pl-stock-texto]');
      var swatchGroups = form.querySelectorAll('[data-pl-opcion-index]');
      var moneyFormat = form.dataset.plMoneyFormat || '{{amount}} €';

      function currentSelection() {
        var sel = [];
        swatchGroups.forEach(function (group) {
          var active = group.querySelector('.pl-producto-swatch.pl-active');
          sel[parseInt(group.dataset.plOpcionIndex, 10)] = active ? active.dataset.value : null;
        });
        return sel;
      }

      function findVariant(sel) {
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === sel[i]; });
        });
      }

      function update() {
        var sel = currentSelection();
        var variant = findVariant(sel);
        if (!variant) return;
        idInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
            compareEl.style.display = '';
            if (descuentoEl) {
              var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
              descuentoEl.textContent = '-' + pct + '%';
              descuentoEl.style.display = '';
            }
          } else {
            compareEl.style.display = 'none';
            if (descuentoEl) descuentoEl.style.display = 'none';
          }
        }
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available
            ? (addBtn.dataset.plLabelDisponible || 'Añadir a la cesta')
            : (addBtn.dataset.plLabelAgotado || 'Agotado');
        }
        if (stockEl) {
          stockEl.style.visibility = variant.available ? 'visible' : 'hidden';
        }
      }

      swatchGroups.forEach(function (group) {
        group.querySelectorAll('.pl-producto-swatch').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            group.querySelectorAll('.pl-producto-swatch').forEach(function (b) { b.classList.remove('pl-active'); });
            btn.classList.add('pl-active');
            update();
          });
        });
      });

      var qtyInput = form.querySelector('[data-pl-qty-input]');
      form.querySelectorAll('[data-pl-qty-minus]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qtyInput) return;
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        });
      });
      form.querySelectorAll('[data-pl-qty-plus]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qtyInput) return;
          qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
        });
      });

      update();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initMarquee();
    initFaq();
    initGaleriaCarrusel();
    initCountUp();
    initProductoGaleria();
    initProductoVariantes();
    initCountdown();
  });
})();
